import { TypedDocumentNode } from '@apollo/client'
import { useQuery, useLazyQuery } from '@apollo/client/react'
import { AdminGooglePlaceByIdQueryDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminGooglePlaceByIdQueryResultFragment, AdminGooglePlaceByIdQueryParams } from '@docpace/admin-graphql'

const typedAdminGooglePlaceByIdQueryDocument = AdminGooglePlaceByIdQueryDocument as TypedDocumentNode<AdminGooglePlaceByIdQueryResultFragment, Partial<AdminGooglePlaceByIdQueryParams>>

export function useAdminGooglePlaceByIdQuery(opts?: useQuery.Options<AdminGooglePlaceByIdQueryResultFragment, Partial<AdminGooglePlaceByIdQueryParams>>){
    return useQuery(typedAdminGooglePlaceByIdQueryDocument, opts)
}

export function useAdminGooglePlaceByIdLazyQuery(opts?: useQuery.Options<AdminGooglePlaceByIdQueryResultFragment, Partial<AdminGooglePlaceByIdQueryParams>>){
    return useLazyQuery(typedAdminGooglePlaceByIdQueryDocument, opts)
}